import { PageContainer } from "@/components/organisms";
import Section from "@/containers/OrderContainer/Common/Section";
import PriceInfo from "@/containers/OrderContainer/Common/PriceInfo";
import "./_orderPriceInfo.scss"

const DisplayInformation = ({ orderDetails }) => {
  // Define sections and their respective data as arrays
  const sections = [
    {
      id: "priceInformation",
      title: "Price Information",
      data: [
        { label: "Total Gross Amount", value: orderDetails?.totalGrossAmount },
        { label: "Total Tax Amount", value: orderDetails?.totalTaxAmount },
        { label: "Total Discount Amount", value: orderDetails?.totalDiscountAmount },
        { label: "Total Promotion Amount", value: orderDetails?.totalPromotionAmount },
        { label: "Total Net Price", value: orderDetails?.totalNetPrice },
      ],
    },
  ];

  return (
    <>
      <div className="order-overview price-info">
        {sections.map((section) => (
          <div key={section.id}>
            {/* Section Title */}
            <div className="grid pl-4">
              <Section id={section.id} title={section.title} icon={section.icon} />
            </div>

            {/* Section Data */}
            <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
              {section.data.map((item) => (
                <PriceInfo
                  label={item.label}
                  value={item.value}
                  isHighlighted={item.isHighlighted}
                  icon={item.icon}
                  key={item.label}
                />
              ))}
            </div>

          </div>
        ))}
      </div>
    </>
  );
};

const OfflineOrderPriceInfoPage = ({ OrderDetails }) => {
  return (
    <PageContainer>
      <DisplayInformation orderDetails={OrderDetails} />
    </PageContainer>
  );
};

export default OfflineOrderPriceInfoPage;
